import { Component, Input, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { SharedModule } from '../../shared.module';
import { MaterialAutoCompleteComponent } from './material-auto-complete.component';

@Component({
  selector: 'app-material-organisation-selector',
  templateUrl: './material-organisationselector.component.html',
  imports:[SharedModule, MaterialAutoCompleteComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MaterialOrganisationSelectorComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MaterialOrganisationSelectorComponent),
      multi: true,
    },
  ],
})
export class MaterialOrganisationSelectorComponent implements OnChanges, ControlValueAccessor, Validator {

  _organisationLanguage!: string;
  _disabled!: boolean;
  _organisations: Organisation[] = [];
  _placeholder!: string;
  _value: Organisation | null = null;

  organisationFormatter: (o: Organisation) => string = () => '';
  onChange = (_value: Organisation | null) => {};
  onTouched = () => {};

    @Input() set placeholder(value: string) {
    if (value) {
      this._placeholder = value;
    }
  }
    @Input() set disabled(value: boolean) {
      this._disabled = value;
    }
    @Input() set organisations(value: Organisation[]) {
      this._organisations = value;
    }
    @Input() set organisationLanguage(value: string) {
      this._organisationLanguage = value;
    }
    @Input() required = false;

    writeValue(value: any): void {
      this._value = value;
    }

    registerOnChange(fn: any): void {
      this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
      this.onTouched = fn;
    }

    valueChanged(event: Organisation | null): void {
      this._value = event;
      this.onChange(event);
      this.onTouched();
    }

    ngOnChanges(changes: SimpleChanges): void {
      if(changes['organisationLanguage']) {
        this.organisationFormatter = (o: Organisation) => o ? o.nameTranslations[this._organisationLanguage] ?? '' : '';
      }
    }

    validate(_control: AbstractControl): ValidationErrors | null {
      if (this.required && !this._value) {
        return { required: true };
      }
      return null;
    }
}
